'use client'

import {TCustomDropDownMenuProps} from "@/app/[locale]/common/components/DropDownMenu/types";
import s from './DropDownMenu.module.scss';
import {CustomIconLink} from "@/app/[locale]/common/components/CustomIconLink/CustomIconLink";
import {Link} from '@/i18n/routing';

export const DropDownMenu = (
    {
        isOpen,
        trigger,
        list,
        leftIcon,
        rightIcon,
        activeRIcon,
        leftMargin,
        href = '#',
        topPaddingContent = 'topPaddingLarge',
        triggerColor = 'blackTriggerColor',
        className,
        handleOpen,
        handleClose,
    }: TCustomDropDownMenuProps) => {
    const activeRightIcon = isOpen ? activeRIcon : rightIcon;
    return (
        <div
            tabIndex={0}
            className={`${s.dropdownMenu} ${className && className}`}
            onMouseLeave={handleClose}
        >
            <CustomIconLink
                href={href}
                rightIcon={activeRIcon ? activeRightIcon : rightIcon}
                leftIcon={leftIcon}
                leftMargin={leftMargin}
                className={`${s.link} ${s[triggerColor]}`}
                onMouseOver={handleOpen}
            >
                { trigger }
            </CustomIconLink>

            {
                isOpen &&
                <div className={`${s.dropdownMenuContainer} ${topPaddingContent && s[topPaddingContent]}`}>
                    <ul className={s.dropdownMenuContent}>
                        {list.map((item, index) => (
                            <li key={index} className={s.dropdownMenuItem}>
                                <Link key={index} href={item.href}>
                                    { item.title }
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            }
        </div>
    );
};